Core.Engine = {
    _animWidth: 0,
    init: function () {
        var _config = Core.Config,
            toggleMenu = false,
            slideOutMenu = false;

        if (Core.Config.Header.MobileMenu == 'dropdown') {
            toggleMenu = true;
        }
        else {
            slideOutMenu = true;
        }

        $.vividCore({
            searchToggle: _config.Header.SearchToggle,
            navigationToggle: _config.Header.NavigationToggle,
            mobileToggleNavigation: toggleMenu,
            mobileSlideOutNavigation: slideOutMenu,
            navigationContainerSelector: "#slide-navigation",
            hasAutoScalingNavigation: _config.Header.AutoScalingNavigation,
            mobileNavigationMaxWidth: _config.Header.MobileNavigationWidth,
            mobileSubMenuToggle: _config.Header.MobileSubMenuToggle,
            cycleSlider: _config.Slider.Active,
            cycleSliderSlideSpeed: _config.Slider.Speed,
            cycleSliderTimeout: _config.Slider.Pause,
            cycleSliderEffect: _config.Slider.Fx,
            accordionTabs: _config.AccordionTabs.Active,
            accordions: _config.Accordions,
            formInputStyling: _config.Forms.InputStyling,
            dropdownStylingTouchDevices: _config.Forms.DropdownStylingTouchDevices,
            dropdownStylingDesktop: _config.Forms.DropdownStylingDesktop,
            responsiveTables: _config.ResponsiveTables.Active
        });

        $.featherlightGallery.prototype.afterContent = function() {
            var caption = this.$currentTarget.attr('title');
            this.$instance.find('.featherlight__caption, .featherlight-next, .featherlight-previous').remove();
            this.$instance.find('.featherlight-content').append(this.createNavigation('previous')).append(this.createNavigation('next'));
            $('<div class="featherlight__caption"><span class="featherlight__caption-content">' + caption + '</span></div>').appendTo(this.$instance.find('.featherlight-content'));
        }

        this.updateAnimWidth();
        $(window).on('resize', this.updateAnimWidth);
        this.filtersToggle();
        this.productMenu('#siteHeader');
        this.categoryMainMenu();
        this.searchFocus();
        this.autoCompleteSearch();
        this.addBlockClass();
        this.newsLetterSignup();
        this.globalToggles();
        this.backToTop();
        this.prefilter();
        this.navHasChildren();
        this.tabContentContainer();
        this.videoEmbedZindex();
        this.getCartSummary();
        this.cartQtyButtons();
        this.ctaBtns();
        this.disableFilters();
        this.printPage();
        this.oneImageSlider();
        this.oneImageBxSlider();
        this.categoryListing();
        this.contentAccordion();
        this.youtubeResize();
        this.youtubeMobile();
        this.quoteToggleHighlight();
        this.disableLinks();
        this.equalItemHeightFirstRun();
        $(window).on('resize', this.equalItemHeight);
        this.initResources();
        $(window).on('resize', this.reflowResources);
        this.menuSubHeight();
        this.storeListingClasses();
        this.megaMenuDelay();
        this.megaMenuTabletInit();
        this.swatchClick();
        this.swatchHover();
        this.filterSummaryInfo();
        this.getPdfResources();
        this.handleAlert();
        this.handleAddressAutocomplete();
        this.handleTopNavDropdown();
        this.handleTooltipTopHeader();
        this.handleAnchorScroll();
        // this.initStickyHeader(); // move to  "megamenu-overflow.js" so it will iniatilize after overflow check

        //set defaults for form validation
        $.validator.setDefaults({ ignore: '' });
        $.validator.addMethod("validate-email", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i.test(value);
        }, "Please enter a valid email address");

        $.validator.addMethod("validate-password", function (value, element) {
            return this.optional(element) || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value);
        }, "Passwords are at least 8 characters with uppercase letters, lowercase letters and at least one number");

        $.validator.addMethod("greaterThan", function (value, element, params) {
            if (!/Invalid|NaN/.test(new Date(value))) {
                return kendo.parseDate(value, "dd/MM/yyyy") > kendo.parseDate($(params).val(), "dd/MM/yyyy");
            }
            return isNaN(value) && isNaN($(params).val())
                || (Number(value) > Number($(params).val()));
        }, 'Must be greater than {0}');

        $.validator.addMethod("validate-date", function (value, element) {
            var currentDate = new Date();
            var day = currentDate.getDate();
            var month = currentDate.getMonth() + 1;
            var year = currentDate.getFullYear();
            var todaysDate = kendo.parseDate((day + "/" + month + "/" + year), "dd/MM/yyyy");
            return this.optional(element) || (kendo.parseDate(value, "dd/MM/yyyy") !== null && kendo.parseDate(value, "dd/MM/yyyy") >= todaysDate);
        }, "Please enter a valid date");

        $.validator.addMethod('empty', function(value, element) {
            return (value === '');
        }, "This field must remain empty.");

        $.validator.addMethod('ukpostcode', function(value, element) {
            if (this.optional(element)) {
                return true;
            }

            return /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/.test(value);
        }, "Please enter a valid post code");

        /**
         * validate phone number according to australian format
         * Ref: https://ilikekillnerds.com/2014/08/regular-expression-for-validating-australian-phone-numbers-including-landline-and-mobile/
         * Ref: https://stackoverflow.com/questions/52127606/how-to-validate-input-field-phone-with-accurate-australian-format-using-jquery-v
         */
        jQuery.validator.addMethod("mobileau", function(value, element) {
            var phoneExpression = /^(?=\d{10}$)(04)\d+/;

            if (!value) return true;

            if (value.match(phoneExpression)) {
                return true;
            }
            return false;
        }, jQuery.validator.messages.mobileau || "Please specify a valid mobile number start with 04");

        $.validator.classRuleSettings.className = { methodName: true };

        /**
         * @see addToCart.js
         */
        Core.AddToQuote.init();

        /**
         * @see carousels.js
         */
        new Core.Carousels();

        /**
         * @see productListing.js
         */
        Core.ProductListing.init();
    },
    updateAnimWidth: function() {
        Core.Engine._animWidth = $('.megaMenu__containers').actual('width') + 40;
        Core.Engine.categorySubResize(true);
    },
    homeToggle: function () {
        Core.Cache.$body.on('click', '.toggle-trigger', function () {
            $('.toggle-container').hide();
            $(this).next().show();
        });
        if (Core.IsMobile()) {
            Core.Cache.$body.on('click', '.toggle-trigger--mobile', function () {
                $('.toggle-container').hide();
                $(this).next().show();
            });
        }
    },
    filtersToggle: function () {
        Core.Cache.$body.on('click', '#filters-toggle', function () {
            $(this).parent().toggleClass('open');
            $(this).parent('.mobile-toggle-btn').siblings('.filters-toggle-wpr').toggle();
        });
    },
    productMenu: function (wrapperId) {
        var _$catListingBlock = $(`${wrapperId} .megaMenu .cataloguelistingblock`),
            _$catListItems = _$catListingBlock.find('ul.nav-panel__link-row');

        if (!Core.IsMobile()) {
            Core.Engine.categorySubResize();
            _$catListItems.first().children().children('a.slide-out').on('click', function (e) {
                e.preventDefault();
                var _$currentCat = $(this).parent().find('.category-sub');
                Core.Engine.categorySubResize();
                _$currentCat.show().addClass('active');
                _$currentCat.find('.cat-img').attr('src', _$currentCat.data('category-image'));

                _$currentCat.find('img').lazyload({
                    event: "lazyload",
                    effect: "fadeIn"
                })
                .trigger("lazyload");

                _$catListingBlock.css('left', (Core.Engine._animWidth * -1) + 'px');
            });
        }

        var _$ctaContainer = _$catListingBlock.find('div.nav-panel__cta-row'),
            _$ctaListItems = _$catListingBlock.find("a.megaMenu__prod-cta[href='#']"); // BACK buttons

        if (!Core.IsMobile()) {
            Core.Engine.categorySubResize();
            _$ctaListItems.on('click', function (e) { // BACK buttons on click
                e.preventDefault();
                var _$currentCat = $(this).parent().find('.category-sub');
                Core.Engine.categorySubResize();
                _$currentCat.show().addClass('active');
                _$currentCat.find('.cat-img').attr('src', _$currentCat.data('category-image'));

                _$currentCat.find('img').lazyload({
                    event: "lazyload",
                    effect: "fadeIn"
                })
                .trigger("lazyload");

                _$catListingBlock.css('left', (Core.Engine._animWidth * -1) + 'px');
            });
        }

        _$catListingBlock.find('.back').on('click', function (e) {
            e.preventDefault();
            _$catListingBlock.css('left', 0);
            setTimeout(function () {
                $('.category-sub.active').removeClass('active').hide();
            }, 600);
        });
    },
    categoryMainMenu: function () {
        $('.slide-out').on('click', function(e) {
            if (Core.IsMobile()) {
                e.preventDefault();
                var url = $(this).data('url');
                if (url) {
                    location.href = $(this).data('url');
                } else {
                    $(this).find(".toggle-icon").trigger('click');
                }
            }
        });
    },
    categorySubResize: function(notransition) {
        notransition = notransition === true ? notransition : false;

        $('ul.nav-panel__link-row .category-sub').each(function() {
            if (notransition) {
                $(this).addClass('notransition');
            }
            $(this).width((Core.Engine._animWidth - 40) + 'px').css('left', (Core.Engine._animWidth - 10) + 'px');
            if (notransition) {
                $(this)[0].offsetHeight;
                $(this).removeClass('notransition');
            }
        });

        $('div.nav-panel__cta-row .category-sub').each(function() {
            if (notransition) {
                $(this).addClass('notransition');
            }
            $(this).width((Core.Engine._animWidth - 40) + 'px').css('left', (Core.Engine._animWidth * 0.350839) + 'px');
            if (notransition) {
                $(this)[0].offsetHeight;
                $(this).removeClass('notransition');
            }
        });

        if ($('.cataloguelistingblock').css('left') && parseInt($('.cataloguelistingblock').css('left')) !== 0) {
            if (notransition) {
                $('.cataloguelistingblock').addClass('notransition');
            }
            $('.cataloguelistingblock').css('left', (Core.Engine._animWidth * -1) + 'px');
            if (notransition) {
                $('.cataloguelistingblock').each(function() {
                    $(this)[0].offsetHeight;
                })
                $('.cataloguelistingblock').removeClass('notransition');
            }
        }
    },
    logout: function () {
        $('#logout').on('click', function (e) {
            e.preventDefault();

            $.ajax({
                url: '/account/logout',
                type: 'GET',
                success: function (data) {
                    if (data) {
                        location.href = '/';
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });
        });
    },
    newsLetterSignup: function () {
        var _$newsletterEmailBtn = $('#newsletter-subscription-btn'),
            _$emailAddress = $("#newsletter-subscription"),
            _$newsletterForm = $("#newsletter-subscription-form"),
            _$newsletterResult = $("p.error"),
            _$buttonKeys = { "EnterKey": 13 };

        _$newsletterEmailBtn.on('click', function (e) {
            e.preventDefault();
            _$newsletterResult.html("");
            var _emailAddress = _$emailAddress.val();
            if (_emailAddress.length > 0) {
                $('#loading-overlay-nl').show();
                $.ajax({
                    url: '/edm/newslettersignup',
                    type: 'POST',
                    dataType: "json",
                    data: _$emailAddress.serialize(),
                    success: function (data) {
                        $('#loading-overlay-nl').hide();
                        if (data.Result !== null) {
                            if (data.Result.toLowerCase() === "ok") {
                                _$emailAddress.val('');
                                _$newsletterResult.html(data.SuccessMessage);
                            } else {
                                _$newsletterResult.html(data.ErrorMessage);
                            }
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        //todo: do something
                        $('#loading-overlay-nl').hide();
                    }
                });
            } else {
                _$newsletterResult.html('Please enter an email address to signup to the newsletter');
            }
        });

        _$newsletterForm.on('keypress', function (e) {
            if (e.which == _$buttonKeys.EnterKey) {
                var defaultButtonId = $(this).attr("defaultbutton");
                $("#" + defaultButtonId).trigger('click');
                return false;
            }
        });
    },
    searchFocus: function () {
        //$("#search-site").blur(function (e) {
        //    if (e.relatedTarget == null || e.relatedTarget.id !== 'btn-search-site') {
        //        $("#search-site").val('');
        //    }
        //});
        //$("#search-site").focus(function (e) {
        //    $("#search-site").val('');
        //});
    },
    autoCompleteSearch: function () {
        var _$input = $("#search-site"),
            _$form = $('#frm-site-search'),
            _$buttonKeys = { "EnterKey": 13 };

        if (_$input.length === 0 )
            return true;

        var dataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function (request, response) {
                        var _$loading = _$form.children('.loading');
                        var _$autocomplete = $("#search-site").data("kendoAutoComplete");

                        var _$filterInput = _$input.val().replace(/[|;$%@"<>(),?+*:]/g, "");

                        _$loading.show();

                        // https://run.mocky.io/v3/df4afccf-71ad-4282-a1d9-37e25fd3f54c
                        $.getJSON('/sitesearch/term/?searchterm=' + encodeURI(_$filterInput), function (json) {
                            request.success(json.Results);
                            _$loading.hide();
                            if (_$filterInput == '') {
                                _$autocomplete.list.hide();
                            }
                        });
                    }
                }
            });

        var autocomplete = _$input.kendoAutoComplete({
            dataTextField: "Name",
            dataSource: dataSource,
            // minLength: Core.Config.SearchAutoComplete.MinCharacters,
            template: kendo.template($("#tpl-auto-search").html()),
            change: function (e) {
                this.dataSource.read();
                if (_$input.is(":focus")) {
                    var _$filterInput = _$input.val().replace(/[|;$%@"<>(),?+*:]/g, "");
                    if (_$filterInput !== '') {
                        var _url = _$form.data('url') + '#?searchTerm=' + encodeURI(_$filterInput);
                        window.location.href = _url;
                    }
                }
            },
            filtering: function(e) {
                var filter = e.filter;
                var _$filterInput = filter.value.replace(/[|;$%@"<>(),?+*:]/g, "");
                if (_$filterInput.length < Core.Config.SearchAutoComplete.MinCharacters) {
                    //prevent filtering if the filter does not value
                    // this.list.hide();
                    e.preventDefault();
                }
            },
            // close: function(e, o, i) {
            //     e.preventDefault(); // prevent close for debugging
            // },
            open: function (e) {
            },
            popup: {
                origin: "bottom center",
                position: "top center"
            }
        }).data("kendoAutoComplete");

        if(autocomplete) {
            autocomplete.popup.element.addClass('k-popup-autocomplete');
        }

        $('#search-site-list').append('<a id="view-all-results" class="view-all-results" href="#">VIEW ALL RESULTS</a>');

        $('#view-all-results, #btn-search-site').on('click', function (e) {
            e.preventDefault();
            var _$autocomplete = $("#search-site").data("kendoAutoComplete");
            var _$filterInput = _$input.val().replace(/[|;$%@"<>(),?+*:]/g, "");

            if (_$filterInput !== '') {
                var _url = _$form.data('url') + '#?searchTerm=' + encodeURI(_$filterInput);
                window.location.href = _url;
                _$autocomplete.close();
            }
        });


        _$form.on('keypress', function (e) {
            if (e.which == _$buttonKeys.EnterKey) {
                var defaultButtonId = $(this).attr("defaultbutton");
                $("#" + defaultButtonId).trigger('click');
                return false;
            }
        });
    },
    addBlockClass: function () {
        $('.cta').parent('.block').addClass('no-padding');
        $('.business-units').parent('.block').addClass('no-padding');
        $('.no-padding').closest('.columns').addClass('no-padding');
    },
    globalToggles: function () {
        $('.toggle-trigger').on('click', function (e) {
            e.preventDefault();
            var _$this = $(this);
            _$this.toggleClass('filter-opened');
            _$this.siblings('.toggle-container').slideToggle(400);
        });
        if (Core.IsMobile()) {
            $('.toggle-trigger--mobile').on('click', function (e) {
                e.preventDefault();
                var _$this = $(this);
                _$this.toggleClass('filter-opened');
                _$this.siblings('.toggle-container').slideToggle(400);
            });
        }
    },
    backToTop: function () {
        function checkPosition() {
            if (Core.Cache.$window.scrollTop() > 200) {
                Core.Cache.$backToTop.fadeIn(500);
            } else {
                Core.Cache.$backToTop.fadeOut(300);
            }
        }

        // Show or hide the sticky footer button
        Core.Cache.$window.on('scroll', checkPosition);

        // Animate the scroll to top
        Core.Cache.$backToTop.on('click', function (e) {
            e.preventDefault();
            Core.Cache.$body.add(Core.Cache.$html).animate({ scrollTop: 0 }, 300);
        });

        checkPosition();
    },
    prefilter: function () {
        var _$prefilter = $('#prefilter');

        if (_$prefilter.length > 0) {
            if (!window.location.hash) {
                var _prefilterVal = _$prefilter.val();
                if (_prefilterVal !== '') {
                    window.location.hash = _prefilterVal;
                }
            }
        }
    },
    navHasChildren: function () {
        $('.megaMenu__nav--link').has('.megaMenu__containers').addClass('has-children');
    },
    tabContentContainer: function () {
        $('.product-extras__container').wrapInner( "<div class='content-area'></div>" );
    },
    //fix z-index mega menu issue on IE8
    videoEmbedZindex: function () {
        $("iframe").each(function(){
            var ifr_source = $(this).attr('src');
            if (ifr_source) {
                var wmode = "wmode=transparent";
                if (ifr_source.indexOf('?') != -1) $(this).attr('src', ifr_source + '&' + wmode);
                else $(this).attr('src', ifr_source + '?' + wmode);
            }
        });
    },
    getCartSummary: function (e) {
        Core.Cache.$miniCartTotal.hide();
        $.ajax({
            url: '/cart/getcounters',
            type: 'GET',
            dataType: "json",
            success: function (data) {
                if (data !== null) {
                    if (data.cartItemsCount !== null && data.cartItemsCount != "0") {
                        Core.Cache.$miniCartTotal.html(data.cartItemsCount);
                        Core.Cache.$miniCartTotal.show();
                    }
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //todo: do something
                //alert(thrownError);
            }
        });
    },
    cartQtyButtons: function () {
        Core.Cache.$body.on('click', '.k-icon', function () {
          $(this).trigger('focus');
        });
    },
    ctaBtns: function () {
       $('.btn-cta .arrow-box').wrapInner( '<span class="cta-text"><span></span></span>' );
    },
    disableFilters: function () {
        setTimeout(function () {
            $('.checker.disabled').closest('label').addClass('disabled');
        }, 1000);
    },
    printPage: function () {
        $('.print').on('click', function (e) {
            e.preventDefault();
            window.print();
        });
    },
    oneImageSlider: function () {
        $('.slider').each(function() {
          if ($('.slide', this).length <= 1) {
            $('.slider-btn, .slider-paging').hide();
          }
        });
    },
    oneImageBxSlider: function () {
        setTimeout(function () {
            $('.carousel').each(function() {
                var slides = $(this).children('li:not(.bx-clone)').length;
                if(slides <= 4) {
                    //need to add this to the CSS to override the important property
                    $(this).parents('.bx-wrapper').children('.bx-controls').attr('style', 'display: none !important');
                }
            });
        }, 300);
    },
    categoryListing: function () {
        var _$categorylist = $('.category__list');
        _$categorylist.find('.category__image').lazyload({
            event: "lazyload",
            effect: "fadeIn"
        })
        .trigger("lazyload");
    },
    contentAccordion: function () {
        var _$footerContent = $('.footer .generic-content');
        _$footerContent.find('h2').addClass('toggle-trigger').siblings().wrap('<div class="toggle-container"></div>');
        _$footerContent.find('h2').on('click', function (e) {
            e.preventDefault();
            var _$this = $(this);
            //_$this.toggleClass('filter-opened').siblings('.toggle-container').slideToggle(400);
        });
    },
    youtubeResize: function () {
        // Find all YouTube videos
        var $allVideos = $("iframe[src^='http://www.youtube.com']"),

            // The element that is fluid width
            $fluidEl = $(".fancybox-inner");

        // Figure out and save aspect ratio for each video
        $allVideos.each(function() {

            $(this)
                .data('aspectRatio', this.height / this.width)

                // and remove the hard coded width/height
                .removeAttr('height')
                .removeAttr('width');

        });

        // When the window is resized
        // (You'll probably want to debounce this)
        $(window).on('resize', function() {

            var newWidth = $fluidEl.width();

            // Resize all videos according to their own aspect ratio
            $allVideos.each(function() {

                var $el = $(this);
                $el
                    .width(newWidth)
                    .height(newWidth * $el.data('aspectRatio'));

            });

            Core.Engine.youtubeMobile();

        // Kick off one resize to fix all videos on page load
        }).trigger('resize');
    },
    youtubeMobile: function () {
        if (Core.IsMobile()) {
            $('.product-details__gallery-actions .icon-play').removeClass('fancybox-media');
        } else {
            $('.product-details__gallery-actions .icon-play').addClass('fancybox-media');
        }
    },
    quoteToggleHighlight: function () {
        $(".k-icon").on('keypress', function() {
            $(this).closest('.k-master-row').toggleClass('active');
        });
    },
    //dynamic tab width
    countAccordionTabs: function() {
        var amount = $('.accordion-tabs > li').length;
        var tabWidth = 100 / parseFloat(amount);
        if (!Core.IsMobile()) {
            $('.product-extras__tab, .tab-block-container .accordion-tabs .tab, .tabsblock .accordion-tabs .tab').css('width', tabWidth + "%");
            if (amount == 1) {
                $('.product-extras__tab, .tab-block-container .accordion-tabs .tab, .tabsblock .accordion-tabs .tab').addClass('single-tab');
            }
        }
    },
    disableLinks: function () {
        $('.disabled').on('click', function (e) {
            e.preventDefault();
        });
    },
    equalItemHeightFirstRun: function() {
        if (!Core.IsMobile()) {
            $('.equal-height').imagesLoaded(Core.Engine.equalItemHeight);
        }
    },
    equalItemHeight: function() {
        if (!Core.IsMobile()) {
            $('.equal-height').removeClass('equal-height-initialised').height('auto');
            $('.equal-height').each(function() {
                if (!$(this).hasClass('.equal-height-initialised')) {
                    var $siblings = $(this).add($(this).siblings('.equal-height'));
                    var tallestHeight = $siblings.map(function (i, el) {
                        return $(el).actual('height');
                    }).get();
                    $siblings.height(Math.max.apply(this, tallestHeight)).addClass('equal-height-initialised');
                }
            });
        }
    },
    menuSubHeight: function() {
        setTimeout(function () {
            var maxHeight = -1;
            var menuItem = $('#main-navigation .megaMenu .megaMenu__nav .megaMenu__nav--link:first-child');
            var menuCategoryMenu = $('#main-navigation .megaMenu .megaMenu__nav .megaMenu__nav--link:first-child .category-sub');

            //maxHeight = maxHeight > menuCategoryMenu.actual('height') ? maxHeight : menuCategoryMenu.actual('height');

            menuCategoryMenu.each(function() {
                maxHeight = maxHeight > $(this).actual('height') ? maxHeight : $(this).actual('height');
            });


            if (!Core.IsMobile()) {
                if (menuItem.children('.megaMenu__containers').height() < maxHeight) {
                    menuItem.children('.megaMenu__containers').height(maxHeight);
                }
            };
        }, 300);
    },
    storeListingClasses: function () {
        setTimeout(function () {
            $('#store-results li:first-child, #store-results li:nth-child(4n+1)').addClass('no-margin');
        }, 1000);
    },
    megaMenuDelay: function () {
        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            if (!Core.IsMobile() && !Core.IsTablet()) {
                var dropdownDelay = 250;
                if (Core.Config.Header.MegaMenuDropdownDelay) {
                    dropdownDelay = Core.Config.Header.MegaMenuDropdownDelay;
                }
                var openDropdownTimeout;

                function megaMenuHoverOn(megaMenuId) {
                    if ($(window).width() > Core.Config.Header.MobileNavigationWidth) {
                        $(megaMenuId).children('.megaMenu__containers').show();
                    }
                }

                function megaMenuOff(megaMenuId) {
                    $(megaMenuId).children('.megaMenu__containers').hide();
                }

                $('.megaMenu__nav .megaMenu__nav--link').each(function () {
                    var $this = $(this);
                    var megaMenuId = $this
                    if (megaMenuId != undefined) {
                        $this.on('mouseenter', function () {
                                openDropdownTimeout = setTimeout(function () {
                                    megaMenuHoverOn(megaMenuId);
                                }, dropdownDelay);
                            }).on('mouseleave', function () {
                                if (openDropdownTimeout)
                                    clearTimeout(openDropdownTimeout);
                                megaMenuOff(megaMenuId);
                            });
                    }
                });
            }
        }
    },
    megaMenuTabletInit: function() {
        if (!Core.IsMobile() && Core.IsTablet()) {
            $(document).on('touchend', '.megaMenu__nav--link.has-children > a', function(e) {
                var o = e.originalEvent;
                var isTouch = o instanceof TouchEvent && o.changedTouches.length === 1;
                if (isTouch) {
                    if (!$(this).hasClass('hover')) {
                        e.preventDefault();
                        e.stopPropagation();
                        $(this).addClass('hover');
                        $(document).one('touchend', '*:not(".megaMenu__nav--link.has-children")', Core.Engine.closeMegaMenu);
                    }
                }
            });
            $(document).on('blur', '.megaMenu__nav--link.has-children > a.hover', function(e) {
                $(this).removeClass('hover');
            });
        }
    },
    closeMegaMenu: function(e) {
        var o = e.originalEvent;
        var isTouch = o instanceof TouchEvent && o.changedTouches.length === 1;
        if (isTouch) {
            e.stopPropagation();
            $('.megaMenu__nav--link.has-children > a.hover').trigger('blur');
        }
    },
    swatchClick: function() {
      $('.swatch').on('click', function() {
        var $this = $(this);
        var $mainImageWrap = $('#main-img');
        var $mainImage = document.querySelector('img.main-image');
        var imageUrl = $this.data('image-url');

        // on image load, remove loading
        $mainImage.addEventListener('load', function() {
          $mainImageWrap.removeClass('is-loading');
        });

        if (imageUrl) {
          $mainImageWrap.addClass('is-loading');
          $mainImage.src = imageUrl;
        }
      })
    },
    swatchHover: function () {
        if (Core.IsMobile() || Core.IsTablet()) {
            $('.swatch').each(function() {
                var $this = $(this);
                var swatch = $this.children('img');
                var $swatchzoom = $('<div class="swatch-zoom"><img src="' + swatch.attr("src") + '"></div>');
                $this.append($swatchzoom);
                $this.on('click', function(ev) {
                    ev.stopPropagation();
                    // $(document).off('click');
                    if ($swatchzoom.hasClass('show')) {
                        $swatchzoom.removeClass('show');
                    } else {
                        $swatchzoom.addClass('show');
                        $(document).one('click touchstart', $('*').not($this), function(e) {
                            $swatchzoom.removeClass('show');
                        });
                    }
                });
            });
        } else {
            $('.swatch')
                .on('mouseenter', function() {
                    var $this = $(this);
                    var swatch = $this.children('img');
                    $this.append('<div class="swatch-zoom"><img src="' + swatch.attr("src") + '"></div>');
                })
                .on('mouseleave', function() {
                    var $this = $(this);
                    $this.children('.swatch-zoom').remove();
                });
        }
    },
    filterSummaryInfo: function () {
        if (Core.IsMobile()) {
            Core.Cache.$body.on('click', '.mobile-toggle-btn', function () {
                //var filterSummary = $('#filter-summary-info').html();
                //$('#filters-summary-info').html(filterSummary);
            });
        }
    },
    /*galleryZoom: function () {
        if($('.main-image').data('zoom-image') != ''){
            $('.main-image').elevateZoom({
                zoomType : "inner",
                zoomWindowFadeIn: 300,
                zoomWindowFadeOut: 300
            });
        }
    },*/
    formDropdownStyling: function () {
        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            if (Core.Config.Forms.DropdownStylingDesktop) {
                $("select:not(.kendo-ignore,.kendo-initialized)").kendoDropDownList().addClass('kendo-initialized');
            }
        } else {
            if (Core.Config.Forms.DropdownStylingTouchDevices) {
                $("select:not(.kendo-ignore,.kendo-initialized)").kendoDropDownList().addClass('kendo-initialized');
            }
        }
    },
    initResources: function() {
        $('.resource-items').each(function(i, el) {
            $(el).imagesLoaded(function initialiseResources () {
                Core.Engine.resourcesEqualHeight(el);
                Core.Engine.closestAccordionTabHeight(el);
            });
        });
        Core.Engine.accordionTabHeight();
    },
    reflowResources: function(context) {
        if (typeof context === "undefined" || typeof context.target !== "undefined" || $(context).length === 0) {
            context = $('body')[0];
        }
        $('.resource-items .grid-item', context).css('height', 'auto'); // first make sure they're in their natural height
        $('.resource-items', context).each(function reflowingResources(i, el) {
            Core.Engine.resourcesEqualHeight(el);
            Core.Engine.closestAccordionTabHeight(el);
        });
        Core.Engine.accordionTabHeight();
    },
    closestAccordionTabHeight: function(el) {
        if (!Core.IsMobile()) {
            $(el).closest('.accordion-tabs .tab > .container.open').each(function() {
                $(this).height($($(this).children('div')[0]).actual('height'));
            });
            $(el).closest('.accordion-tabs').each(function() {
                $(this).height($($(this).find('.tab.active > .container.open > div')[0]).actual('height') + 160);
            });
        }
    },
    accordionTabHeight: function(el) {
        if (!Core.IsMobile()) {
            // resize accordion tab height according to the content of the active one
            $('.accordion-tabs .tab > .container.open').each(function() {
                $(this).height($($(this).children('div')[0]).actual('height'));
            });
            $('.accordion-tabs').each(function() {
                $(this).height($($(this).find('.tab.active > .container.open > div')[0]).actual('height') + 160);
            });
        } else {
            $('.accordion-tabs .tab > .container.open, .accordion-tabs').css('height', 'auto');
        }
    },
    resourcesEqualHeight: function(el) {
        var maxHeight = -1;
        $('.grid-item', el).each(function() {
            if (maxHeight < $(this).height()) {
                maxHeight = $(this).height();
            }
        })
        $('.grid-item', el).height(maxHeight + 'px');
    },
    getPdfResources: function(e) {
      // this is so hacky and tricky cause we can't change the html from editor (category section)
      var $catSection = $('#category-section');

      var $el = $('.resource-search');
      var $input = $el.find('.resource-search-input');
      var $submitBtn = $el.find('.resource-search-submit-btn');
      var $clearBtn = $el.find('.resource-search-clear-btn');
      var $linkWrap = $('#category-section .generic-content').find('table');

      var mainCategories = $('.category-title').map((i, obj) => $(obj).text().replace(/\s/g,'').toLowerCase());
      var categoriesResult = [];
      var noresult = [];


      // remove whitespaces; override table style
      var cleanup = function() {
        $linkWrap.css('height', 'auto');
        $linkWrap.find('tbody tr').css('height', 'auto');
        $linkWrap.find('tbody td').css({
          'vertical-align': 'top',
          'height': 'auto'
        });

        $linkWrap.find('tbody td p').map(function() {
          var $this = $(this);
          $this.find('br').remove();
          this.innerHTML = $this.html().replace(/&nbsp;/g, '');
          if ($this.html().length === 0) $this.remove();
        });
      };

      var reset = function() {
        $('.resourcelistingblock').hide(); // hide all rows first
        $('.resourcelistingblock .resource-items .grid-item').hide(); // hide all items first
        // reset highlight
        $('.resourcelistingblock .resource-items .grid-item .doc h3').map(function(index, item) {
          var originalTitle = $(item).data('title');
          if (originalTitle) {
            $(item).html(originalTitle);
          }
        });

        $('.resource-search-no-results').remove();
      };

      // green links under the serach box
      var handleCategorySection = function(cat) {
        // get all names, make into array of string
        mainCategories.map(function(i, item) {
          var foundCat = cat.find(o => o.name.replace(/\s/g,'').toLowerCase() === item);
          if (foundCat) {
            foundCat.subcategories.map(function(subcat) {
              categoriesResult.push(subcat.name.toLowerCase());
            });
          } else {
            noresult.push(item.replace(/\s/g,'').toLowerCase());
          }
        });

        // map each links element
        // selector is a bit complex since the content doesn't have specific class
        $linkWrap.find('td p a').map(function(i, el) {
          var $link = $(el);
          // check if it's Categories title or not
          if ($link.closest('strong').length === 0) {
            // if (categoriesName.indexOf($link.text().toLowerCase()) >= 0) {
            // check if category contains string eg: bathroom in Bathroom User Documents
            if (categoriesResult.find(obj => obj.includes($link.text().toLowerCase()))) {
              $link.show();
              $link.next('br').show();
            } else {
              $link.hide();
              $link.next('br').hide();
            }
          } else {
            if (noresult.indexOf($link.text().replace(/\s/g,'').toLowerCase()) >= 0) {
              $link.closest('td').append('<div class="resource-search-no-results">No results</div>');
            }
          }
        });
      };

      var handleItems = function(subcat) {
        // show/hide categories
        var subcatId = $('.resourcelistingblock .resources-container').find('h2#' + subcat.id);
        if (subcatId) {
          $(subcatId).closest('.resourcelistingblock').show();
        }

        // show/hide items
        subcat.Resources.map(function(item) {
          var itemId = $('.resourcelistingblock .resource-items').find('.grid-item#' + item.id);
          if (itemId) {
            // highlight keyword
            var $title = $(itemId).find('.doc h3');
            var text = $title.text();
            var keyword = $input.val();
            var index = text.toLowerCase().indexOf(keyword.toLowerCase());
            $title.data('title', text);
            if (index >= 0) {
              // var addSpace = text.substr(index + keyword.length + 1, 1) === ' '; // check if next character is space or not
              var innerHTML = text.substring(0, index) + "<span class='resource-search-highlight'>" + text.substring(index, index + keyword.length) + "</span>" + text.substring(index + keyword.length);
              $title.html(innerHTML);
            }

            $(itemId).show();
          }
        });

        // show hide item sections (row)
        $('.category-title').map(function(i, obj) {
          var $title = $(obj);
          var foundCat = noresult.find(o => o === $title.text().replace(/\s/g,'').toLowerCase());
          if (foundCat) {
            $title.hide();
          } else {
            $title.show();
          }
        });
      };

      var doSearch = function() {
        var keyword = $input.val();
        if (!keyword) return;

        $catSection.addClass('is-loading');
        categoriesResult = [];
        noresult = [];

        // /sitesearch/Resources/?searchTerm=BoardingPass
        // https://run.mocky.io/v3/cd51d9c0-ec76-4920-80f3-6be9ac2fb17f
        // no results: https://run.mocky.io/v3/43b67612-b46d-4255-9795-045937ad1d8c
        $.getJSON('/sitesearch/Resources/?searchterm=' + encodeURI(keyword), function (resp) {
          var categories = resp.categories;

          reset();
          handleCategorySection(categories);
          if (categories.length > 0) {
            categories.map(function(cat) {
              // check subcategories
              cat.subcategories.map(function(subcat) {
                handleItems(subcat);
              });
            });
          } else {
            $('.category-title').hide();
          }
          $catSection.removeClass('is-loading');
        });
      };

      $input.on('keyup', function(e) {
        var key = e.keyCode || e.which;
        // capture enter
        if (key == 13){
          doSearch();
        }

        // determine to show search/clear icon
        if ($input.val().length > 0) {
          $clearBtn.show();
        } else {
          $clearBtn.hide();
        }
      });

      $submitBtn.on('click', function() {
        doSearch();
      });

      $clearBtn.on('click', function() {
        $input.val('');
        $clearBtn.hide();
        $('.resource-search-no-results').remove();
        $('.generic-content').find('table tbody td p a').show(); // show all links section
        $('.resourcelistingblock .resource-items .grid-item').show(); // show as per page load
        $('.resourcelistingblock').show(); // show as per page load
        $('.category-title').show();
      });

      cleanup();
      $catSection.addClass('is-initialized');
    },

    handleAlert: function() {
      var LS_ALERT = 'aidacare.alertBlock.closed';
      var currentLsAlert = localStorage.getItem(LS_ALERT) || [];

      if (currentLsAlert.length > 0) {
        currentLsAlert = JSON.parse(currentLsAlert);
      }

      $('[data-dismiss="alert"]').on('click', function() {
        var $this = $(this);
        var $parent = $this.closest('.alert');
        if ($parent?.length > 0) {
          var id = $parent.data('id');
          currentLsAlert.push(id);

          if (currentLsAlert.length > 0) {
            localStorage.setItem(LS_ALERT, JSON.stringify(currentLsAlert));
          }
          $parent.remove();
        }

      });

      // remove alert if the value is on localstorage, else show alert
      $('.alert.alert-dismissible').each(function(i, obj) {
        var $this = $(this);
        var id = $(obj).data('id');
        if (currentLsAlert.find(o => o === id)) {
          $this.remove();
        } else {
          $this.removeClass('d-none');
        }
      });
    },

    handleAddressAutocomplete: function() {
      var _$input = $('.addressAutocomplete-input');
      var fetchUrl = _$input.closest('.addressAutocomplete').data('fetch-api');

      if (_$input && _$input.length > 0 && !fetchUrl) {
        console.log('addressAutocomplete :: Please provide "data-fetch-api" attribute to addressAutocomplete element');
        return;
      }

      _$input.map(function(i, inp) {
        var $inp = $(inp);
        var selectedVal;
        var autocomplete = $inp.data('kendoAutoComplete');

        if (autocomplete) return;

        var dataSource = new kendo.data.DataSource({
          serverFiltering: true,
          transport: {
            read: function (request, response) {
              var url = `${fetchUrl}?query=${$inp.val()}`;

              $.getJSON(url, function (response) {
                if (response && Array.isArray(response) && response.length > 0) {
                  response.map(function(item) {
                    // add new prop to combine suburb, state, and postcode
                    item.customText = `${item.locality}, ${item.state}, ${item.postcode}`;
                    return item;
                  })
                }
                request.success(response);
              });
            },
          },
        });

        autocomplete = $inp.kendoAutoComplete({
          dataTextField: "customText",
          dataSource: dataSource,
          minLength: Core.Config.SearchAutoComplete.MinCharacters,
          template: `
            <div class="addressAutocomplete-item">
                #:locality#, #:state#, #:postcode#
            </div>
          `,
          change: function (e) {
            var obj = e.sender;
            // compare current val with selected, if different, call api
            if (obj.value() !== $inp.val()) {
              this.dataSource.read();
            }
          },
          select: function(e) {
            var $el = $(e.sender.element);
            var $parent = $el.closest('.addressAutocomplete');
            var item = e.dataItem;
            selectedVal = item.customText;

            $parent.find('.addressAutocomplete-suburb').val(item.locality);
            $parent.find('.addressAutocomplete-state').val(item.state);
            $parent.find('.addressAutocomplete-postcode').val(item.postcode);
          },
          filtering: function(e) {
            var filter = e.filter;
            var _$filterInput = filter.value.replace(/[|;$%@"<>(),?+*:]/g, "");
            if (_$filterInput.length < Core.Config.SearchAutoComplete.MinCharacters) {
                // prevent filtering if the filter does not have value
                e.preventDefault();
            }
          },
        }).data("kendoAutoComplete");

        $inp.on('blur', function() {
          // force to select prev selection
          var curVal = $inp.val();
          if (curVal !== selectedVal) {
            $inp.val(selectedVal);
          }
        });

        if(autocomplete) {
          autocomplete.popup.element.addClass('k-popup-autocomplete addressAutocomplete-popup');
        }
      });
    },

    handleTopNavDropdown: function() {
        $(".top-nav-dropdown").kendoMenu({
            animation: false,
            hoverDelay: 0,
        });
    },

    handleTooltipTopHeader: function() {
        $('.topHeaderMenu-tooltip').kendoTooltip({
            width: 200,
            position: "bottom",
            showOn: "click mouseenter",
            show: function(e) {
                var popupObj = this.popup;
                popupObj.element.addClass('text-center topHeaderMenu-tooltip-popup');
                // append the close button if it doesn't exist
                if (!popupObj.element.find('.topHeaderMenu-tooltip-close').length) {
                    popupObj.element.append('<span class="fa fa-times topHeaderMenu-tooltip-close"></span>');
                    // bind the close button
                    popupObj.element.find('.topHeaderMenu-tooltip-close').on('click', function() {
                        popupObj.close();                        
                    });
                }
            },
        });
    },

    handleAnchorScroll: function() {
        $(document).off('click.anchorScroll').on('click.anchorScroll', 'a[href*="#"]', function(e) {
            var href = $(this).attr('href');
            var hashIndex = href.indexOf('#');
            
            if (hashIndex === -1) return;

            var hash = href.substring(hashIndex);
            var pagePath = href.substring(0, hashIndex);

            // only handle if it's the current page or a pure hash link
            if (pagePath) {
                try {
                    var normalizedPath = new URL(pagePath, window.location.href).pathname.replace(/\/$/, '');
                    var currentPath = window.location.pathname.replace(/\/$/, '');
                    if (normalizedPath !== currentPath) return;
                } catch (ex) {
                    return;
                }
            }

            if (hash === '#') return;

            var $target = $(hash);
            if ($target.length === 0) return;

            e.preventDefault();

            var stickyHeaderHeight = 0;
            var $stickyHeader = $('#stickyHeader');
            if ($stickyHeader.length > 0 && $stickyHeader.hasClass('sticky')) {
                stickyHeaderHeight = $stickyHeader.outerHeight(true);
            }

            var OFFSET = 16; // additional offset for spacing
            var targetOffset = $target.offset().top - stickyHeaderHeight - OFFSET;

            $('html, body').animate({ scrollTop: targetOffset }, 500);
            location.hash = hash; // update hash without jumping
        });
    },

    initStickyHeader: function() {
        var $sticky = $("#stickyHeader");
        if ($sticky.length === 0) return;
        
        $sticky.empty(); // reset content
        var header = document.getElementById("siteHeader");
        var headerStickyOffset = header.offsetTop + header.offsetHeight;

        // copy elements that will show on sticky header
        var $topHeaderMenu = $('.topHeaderMenu');
        var $topNav = $('#siteHeader .top-nav-wrapper.wrapper').clone();
        var $pageNav = $('#siteHeader #page-navigation').clone();

        // append to sticky header
        if ($topHeaderMenu.length > 0) {
            $sticky.append($topHeaderMenu.clone());
        }
        $sticky.append($topNav);
        $sticky.append($pageNav);

        // remove all nested children's id attribute within sticky header element
        $sticky.find('div[id]').removeAttr('id');
        // $sticky.find('.toggle-cart-btn').removeAttr('id');
        $sticky.find('.icon-close-green').removeAttr('id'); // fix for mobile menu close        

        this.megaMenuDelay();
        this.handleTooltipTopHeader();
        this.handleTopNavDropdown();
        this.productMenu('#stickyHeader');

        // init kendo menu for sticky header
        var $moreKendoMenu = $sticky.find('.megaMenu__nav--more');
        if ($moreKendoMenu.length > 0) {
            if ($moreKendoMenu) {
                // Destroy existing widget if it exists
                var kendoWidget = $($moreKendoMenu).data('kendoMenu');
                if (kendoWidget) kendoWidget.destroy();
                
                // Initialize/re-initialize the menu
                $($moreKendoMenu).kendoMenu({
                    animation: false,
                    hoverDelay: 0,
                    direction: "bottom right"
                });
            }
        }

        window.onscroll = function () {
          if (window.pageYOffset > headerStickyOffset) {
            $sticky.addClass("sticky");
          } else {
            $sticky.removeClass("sticky");
          }
        };
    }
};
